import { env } from '../config/env';

const API_BASE_URL = env.apiBaseUrl;

export async function apiRequest(path, token, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  const payload = await response.json().catch(() => ({}));

  const message = payload.message || 'Unable to complete request.';
  const shouldForceSignOut =
    response.status === 401 ||
    (response.status === 403 &&
      typeof payload.message === 'string' &&
      (payload.message.includes('deactivated') ||
        payload.message.includes('owner admin account is inactive')));

  if (shouldForceSignOut) {
    localStorage.removeItem('crmAuthToken');
    window.location.reload();
    return new Promise(() => {}); // Halt further execution of the caller
  }

  if (!response.ok) {
    throw new Error(message);
  }

  return payload;
}
